module.exports = __webpack_public_path__ + "static/quick-fin-white-bf80a5c9b2a1ecf010a47e91f041d177.svg";